namespace Matrix.Indexation {
    export namespace FactIndexationProfileSecurityService {
        export const baseUrl = 'Indexation/FactIndexationProfileSecurity';

        export declare function Create(request: Serenity.SaveRequest<FactIndexationProfileSecurityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FactIndexationProfileSecurityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FactIndexationProfileSecurityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FactIndexationProfileSecurityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Indexation/FactIndexationProfileSecurity/Create",
            Update = "Indexation/FactIndexationProfileSecurity/Update",
            Delete = "Indexation/FactIndexationProfileSecurity/Delete",
            Retrieve = "Indexation/FactIndexationProfileSecurity/Retrieve",
            List = "Indexation/FactIndexationProfileSecurity/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>FactIndexationProfileSecurityService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
